<template>
  <div class="side-delete-btn-box">
    <div class="side-delete-btn" v-bind:class="{ 'disabled': complete !== true}" @click="deleteJob">
      <i class="far fa-trash-alt"></i>
      {{ 'Delete' | trans }}
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import {EventBus} from "../../events/event.bus";
import {EVENT_JOB_DELETE_INIT} from "../../events/job.events";

export default {
  name: "DeleteBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    deleteJob() {
      if (this.currentJob.state === 'not_found') {
        return;
      }
      EventBus.$emit(EVENT_JOB_DELETE_INIT, this.currentJob);
    },
    exportJob() {
      if (this.complete) {
        JobManager.export(this.id);
      }
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.side-delete-btn {
  //background: #1266F1;
  border: 2px solid #FF1111;
  color: #FF1111;
  //color: white;
  height: 45px;
  padding: 10px 10px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;

  &:hover {
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
